import React from 'react'
import { ReactComponent as ClickAndCollectLogo } from '../assets/images/cc-logo.svg'

const Header = () => {
  return (
    <header className="text-2xl mb-6 lg:mb-8">
      <h1 className="text-hidden text-white block overflow-hidden whitespace-no-wrap indent-header">
        Morrisons Click &amp; Collect
      </h1>
      <ClickAndCollectLogo />
    </header>
  )
}

export default Header
